import { useEffect, useState } from 'react';

// Vrai tant que la media query CSS correspond (ex. '(max-width: 640px)'),
// mis à jour au redimensionnement / à la rotation de l'écran.
export default function useMediaQuery(query) {
    const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

    useEffect(() => {
        const mediaQueryList = window.matchMedia(query);
        const handleChange = () => setMatches(mediaQueryList.matches);
        handleChange();
        mediaQueryList.addEventListener('change', handleChange);
        return () => mediaQueryList.removeEventListener('change', handleChange);
    }, [query]);

    return matches;
}
